import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Column } from "styled-grid-system-component"
import Styles from "../SharedComponents"
import styled from "styled-components"

const Description = styled.p`
  margin-bottom: 10px;
`
const AboutPage = () => {
  const data = useStaticQuery(
    graphql`
      query {
        cvDescription: dataJson {
          description
        }
      }
    `
  )

  const {
    cvDescription: { description },
  } = data

  return (
    <Styles.RowMargined>
      <Column xs={12}>
        <Styles.Header>About me</Styles.Header>
        {description.split("**").map((section, key) => (
          <Description key={`key_${key}`}>{section}</Description>
        ))}
      </Column>
    </Styles.RowMargined>
  )
}

export default AboutPage
